import { useAssetActionModalStore } from '@/store/asset-action-modal.store';
import { ListViewItem } from '@ingka/list-view';
import { translate } from '@repo/phrase';

import { MODAL } from '@/components/modals/asset-modal.types';

import type { AssetActionProps } from '../../asset-context-buttons.types';

const AssetExportListItem = ({ onClose, context }: AssetActionProps) => {
    const setActiveModal = useAssetActionModalStore((state) => state.setActiveModal);
    return (
        <ListViewItem
            title={translate('order_status_header_export')}
            control="navigational"
            controlIcon={context === 'modal' ? 'chevronRight' : null}
            inset={context === 'dropdown'}
            emphasised={context === 'modal'}
            onClick={() => {
                setActiveModal(MODAL.EXPORT);
                onClose?.();
            }}
        />
    );
};

export const AssetExportAction = ({ type, ...props }: AssetActionProps) => {
    if (type === 'button') {
        return null;
    }
    return <AssetExportListItem key="export-list-item" {...props} />;
};
